var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#08AF54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 6.1665C8.78285 6.1665 6.16602 8.78334 6.16602 11.9998C6.16602 15.2163 8.78285 17.8332 11.9993 17.8332C15.2158 17.8332 17.8327 15.2163 17.8327 11.9998C17.8327 8.78334 15.2158 6.1665 11.9993 6.1665ZM11.9993 16.6665C9.42627 16.6665 7.33268 14.5729 7.33268 11.9998C7.33268 9.42675 9.42627 7.33317 11.9993 7.33317C14.5724 7.33317 16.666 9.42675 16.666 11.9998C16.666 14.5729 14.5724 16.6665 11.9993 16.6665Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5827 9.0835H11.416V12.2417L13.3369 14.1626L14.1618 13.3377L12.5827 11.7587V9.0835Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLeft);
export default __webpack_public_path__ + "static/media/time-left.20ae50e0.svg";
export { ForwardRef as ReactComponent };